import { State, DataResult } from '@progress/kendo-data-query';

export class Info implements IInfo {
  genericSuccess: string;
  genericError: string;
  genericInProgress: string;
  inProgressMessage = "Saving Data. Please wait";
  successMessage = "Details saved successfully";
  errorMessage="An error occured. Please try again"
}
export interface IInfo {
  genericSuccess: string;
  genericError: string;
  genericInProgress: string;
}

export interface GridSettings {
    columnsConfig: ColumnSettings[];
    state: State;
    gridData?: DataResult;
}
export interface ColumnSettings {
    field: string;
    title?: string;
    filter?: 'string'|'numeric'|'date'|'boolean';//was filter donno why
    format?: string;
    width?: number;
    _width?: number;
    filterable: boolean;
    orderIndex?: number;
    hidden?: boolean;
    widthForPDF?: number;
}

